import { render } from "./NewGoalActivityPanel.vue?vue&type=template&id=ec8b7baa"
import script from "./NewGoalActivityPanel.vue?vue&type=script&lang=js"
export * from "./NewGoalActivityPanel.vue?vue&type=script&lang=js"
script.render = render

export default script